import Backbone from "backbone";
import _ from "underscore";
import template from "./template.html";

let FloorPlanListView = Backbone.View.extend({
    template,
    className: "fp-panel active",
    id: "fp_view_start",
    attributes: {
        role: "tabpanel"
    },
    events: {
        "click .fp": "selectFloorPlan",
        "click .bed-header": "expandCategory"
    },
    initialize: function(options) {
        this.options = _.defaults({}, options, {
            availabilityString: "Available",
            applyString: "Apply To Waitlist",
            useAccordionOption: true,
            accordionOption: this.collection.length > 4 ? "First Open" : "All Open",
            showFloorplanThumbnail: false,
            displayRent: false,
            displayDeposit: false
        });
        this.openGroups = this.getInitialOpenGroups();

        // Expand/contract handlers
        this.$el.on("show.bs.collapse", "[data-group]", (e) => {
            const group = e.currentTarget.getAttribute("data-group");
            this.openGroups.add(group);
        });
        this.$el.on("hide.bs.collapse", "[data-group]", (e) => {
            const group = e.currentTarget.getAttribute("data-group");
            this.openGroups.delete(group);
        });
    },
    getInitialOpenGroups: function() {
        const groupNames = Array.from(this.collection.groups().keys());
        const { useAccordionOption, accordionOption } = this.options;

        if (!useAccordionOption || accordionOption === "First Open") {
            return new Set([groupNames[0]]);
        } else if (accordionOption === "All Open") {
            return new Set(groupNames);
        }
        return new Set();
    },
    render: function() {
        let {openGroups} = this;
        let scroll = 0;
        let scroller = this.el.querySelector("#floorplan_list");
        if (scroller && scroller.scrollTop) {
            scroll = scroller.scrollTop;
        }

        const groups = this.collection.groups();
        const fpLength = this.collection.length;

        const {availabilityString, applyString, accordionOption,
                showFloorplanThumbnail, displayRent, displayDeposit} = this.options;

        const context = {
            groups,
            openGroups,
            fpLength,
            availabilityString,
            applyString,
            accordionOption,
            showFloorplanThumbnail,
            displayRent,
            displayDeposit,
        };

        this.$el.html(this.template(context));

        const active = this.collection.getActive();
        if (active) {
            this.setActive(active.get("id"));
        }

        const floorPlan = this.floorPlan;
        const units = floorPlan ? floorPlan.getUnits() : [];

        this.$el.toggleClass("no-units", floorPlan && !units.length);

        // re-obtain scroller since the html has been re-written at this point.
        scroller = this.el.querySelector("#floorplan_list");

        if (scroll) {
            scroller.scrollTop = scroll;
        }
        return this;
    },
    findGroup: function(group) {
        return this.$el.find(`[data-group="${group}"]`);
    },
    show: function($elems) {
        // We can't use jQuery's show method, because it calculates
        // styles in an undesired method which breaks this view
        // as a result of themes setting all the things to display: inline-block.
        $elems.css("display", "");
    },
    selectFloorPlan: function(e) {
        let elem = e.currentTarget;
        let id = parseInt(elem.id.substr(2), 10);
        let fp = this.collection.find({id});

        let showUnits = fp && fp.get("units").length && !fp.getHideUnitAvailability();
        let tab = showUnits ? "#fp_view_units" : "#fp_view_detailed";

        this.trigger("tab", tab);

        this.setActive(id);

        this.collection.setActive(id);
    },
    expandCategory: function(e) {
        this.$el.find(e.currentTarget).toggleClass("collapsed");
        this.$el.find(e.currentTarget.getAttribute("data-target")).collapse("toggle");
    },
    setActive: function(id) {
        this.$el.find(".fp").removeClass("active");
        this.$el.find("#fp" + id).addClass("active");
    }
});

export {FloorPlanListView};
